import { GenericTradeParams } from '@ui/features/Trade/types';
import { useTranslation } from 'next-i18next';

export const useUpdateTradeTpAndSlToastOpts = ({
  genericTradeParams,
}: GenericTradeParams) => {
  const { t } = useTranslation();

  return {
    onMutateToastOpts: {},
    onSuccessToastOpts: {
      description: t('common.Stop Loss/Take Profit trade update successfully'),
    },
    onErrorToastOpts: {},
  };
};
